/*
 * Locks 1% of the viewport height into --da-locked-vh at load so that
 * full-viewport sections keep a fixed pixel height while iOS Chrome
 * resizes the layout viewport during toolbar show/hide on scroll.
 * Re-locks when the viewport width changes (orientation / real window
 * resize). Small height-only changes come from the browser toolbars and
 * are ignored.
 *
 * In-app browsers (TikTok, Instagram, Facebook ads) open the page in a
 * sheet that slides up from the bottom, so at load innerHeight can be
 * only half the screen. A height *increase* larger than any toolbar
 * show/hide means the sheet finished expanding — re-lock then, otherwise
 * the full-screen hero stays stuck at the half-open height.
 */
(function () {
  if (window.__daViewportLockInit) {
    return;
  }
  window.__daViewportLockInit = true;

  /* iOS / Android toolbars move the viewport by well under this. */
  var SHEET_GROWTH_PX = 150;
  var lockedWidth = 0;
  var lockedHeight = 0;

  function lock() {
    lockedWidth = window.innerWidth;
    lockedHeight = window.innerHeight;
    document.documentElement.style.setProperty(
      '--da-locked-vh',
      (window.innerHeight / 100) + 'px'
    );
  }

  lock();

  function needsRelock() {
    return window.innerWidth !== lockedWidth
      || window.innerHeight - lockedHeight > SHEET_GROWTH_PX;
  }

  function maybeRelock() {
    if (needsRelock()) {
      lock();
    }
  }

  window.addEventListener('resize', maybeRelock, { passive: true });

  /* Some in-app webviews expand the sheet without firing resize on window. */
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', maybeRelock, { passive: true });
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      maybeRelock();
    }
  });
})();
